/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ToggleIcon/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaIconArrowDown from 'DesignSystem/Svgs/TysiaIconArrowDown/index'
import TysiaIconArrowUp from 'DesignSystem/Svgs/TysiaIconArrowUp/index'



/** @type {import('Simple/types.js').View} */
export default function ToggleIcon({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Menu/Expanded/BoardsArchived/Content/ToggleIcon"
  
}) {
  let flow = fromFlow.useFlow()
  return (<React.Fragment
>
<fromFlow.When is={flow.has(fromFlow.normalizePath(viewPath, '../Boards/No'))}>
<TysiaIconArrowDown
  viewPath={`${viewPath}/TysiaIconArrowDown`}
/>
</fromFlow.When>
<fromFlow.When is={flow.has(fromFlow.normalizePath(viewPath, '../Boards/Content'))}>
<TysiaIconArrowUp
  viewPath={`${viewPath}/TysiaIconArrowUp`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}